var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoIssueGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_issue_group",
    d: "M193.67,716.028a3.535,3.535,0,1,1-3.4,3.532A3.467,3.467,0,0,1,193.67,716.028Zm11.144,13.788a5.4,5.4,0,0,0-5.076-4.977V722.71a.431.431,0,0,0-.222-.387.346.346,0,0,0-.408.072l-3.766,3.809a.459.459,0,0,0,0,.63l3.764,3.815a.348.348,0,0,0,.253.109.344.344,0,0,0,.155-.037.43.43,0,0,0,.223-.387v-2.117h.182c1.766,0,3.27,1.578,4.021,2.93l.379.682a.369.369,0,0,0,.319.2.336.336,0,0,0,.125-.025.428.428,0,0,0,.245-.451Zm-6.422,1.531-3.783-3.833a1.464,1.464,0,0,1,.019-2.008l1.711-1.731a1,1,0,0,0-.535.2,3.3,3.3,0,0,1-4.229-.021,1,1,0,0,0-.61-.217.652.652,0,0,0-.2.029,6.159,6.159,0,0,0-3.742,5.322c-.091.83.348,2.852,6.633,2.883h.138a13.644,13.644,0,0,0,4.613-.612Z",
    transform: "translate(-187.012 -716.028)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoIssueGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_issue_group.aec83fe25cbc7ea28a97ab5e647acb70.svg";